import Hook from "../hook"

/** Rent Order Item / Quickrent */
class TaskHook extends Hook {
  async afterCreate(window) {
    if (window.output.Request.Subject !== "Core.vw_Tasks") {
      return
    }

    window.output.Request.Data.SortOn = ["DueDate", "ID"]
    // window.output.Request.Data.filters.usedate = true
    console.log(window.output.Request.Data.SortOn)
    // if (window.output.Request.Subject == "Rental.vw_PlanningDesiredDelivery" || window.output.Request.Subject == "Rental.vw_PlanningExpectedItems") {
    //     // Get all filters and the clientside 'until' filter
    //     let currentDateFilter = window.output.Request.Data.Filters
    //     let dateUntilFilter = window.filters.date[1]
    //     // Only if the DateTimeCreated <= filter is not null, and the clientside value is null, we need to set this to be able to show this on the clientside.
    //     // Afterwards, we need to delete the filter, otherwise the user cannot delete this filter, because it enters this if statement again.
    if (
      currentDateFilter["DateTimeCreated <="] != null &&
      dateUntilFilter.value == null
    ) {
      dateUntilFilter.value = Formatter.parsers.Date(
        currentDateFilter["DueDate <="],
      )
      window.output.Request.Data.Filters = {}
    }
    // }
  }

  async beforePaginate(window) {
    if (window.output.Request.Subject !== "Core.vw_Tasks") {
      return
    }
    // window.output.Data.Type = "horizontalagenda "

    // TODO replace DateTimeCreated with DueDate when gathering new data for time based filtering
  }

  /**
   * Setup values
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterProcess(window) {
    if (window.output.Request.Subject !== "Core.vw_Tasks") {
      return
    }
    let selectedTaskDescription =
      window.output.Request.Data.Filters.TaskDescription
    let selection = 0
    if (selectedTaskDescription === "IncomingItem") {
      selection = 1
    } else if (selectedTaskDescription === "OutgoingItem") {
      selection = 2
    }

    window.output.Data.Type = "horizontalagenda"
    window.filters.usedate = true
    window.output.Filters = []
    window.output.Filters.push({
      Location: 1,
      Ranking: 0,
      Target: "TaskDescription",
      Text: null,
      Type: "List",
      Selected: selection,
      Options: [
        {
          Key: window.session.translations.All,
          Value: null,
        },
        {
          Key: window.session.translations.IncomingItem,
          Value: "IncomingItem",
        },
        {
          Key: window.session.translations.OutgoingItem,
          Value: "OutgoingItem",
        },
      ],
    })
  }
}

/** @ignore */
export default new TaskHook()
